module.exports = __webpack_public_path__ + "img/Sundae_Logo.e3ab8877.png";